import { BackgroundColorPalette } from "lib/styles/colors";
import { ReactElement } from "react";
import styled from "styled-components";
import Text, { TextType } from "components/Text";

interface StyleProps {
  noMargin?: boolean;
}
const HeaderContainer = styled.div`
  display: flex;
  width: 100%;
  margin-top: 40px;
  justify-content: center;
  align-items: center;
`;

const TextContainer = styled.div<StyleProps>`
  border-bottom: 8px solid ${BackgroundColorPalette.BASIC_DECORATION_BLUE};
  padding: 12px;
  ${({ noMargin }) => `
    margin-bottom: ${noMargin ? "0px" : "32px"};
  `}
`;

interface Props {
  header: string;
  noMargin?: boolean;
}

export default function SettingsPageHeader({
  header,
  noMargin,
}: Props): ReactElement {
  return (
    <HeaderContainer>
      <TextContainer noMargin={noMargin ?? false}>
        <Text
          type={TextType.HEADING_MEDIUM}
          style={{ textTransform: "capitalize" }}
        >
          {header}
        </Text>
      </TextContainer>
    </HeaderContainer>
  );
}
